(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rb-gift-message"] && !Shopify.designMode) return;
  try {
    (function () {
    var saveTimer;
    var pendingSave = Promise.resolve();

    function cartUpdateUrl() {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      return (root || '/') + 'cart/update.js';
    }

    function saveMessage(value) {
      pendingSave = pendingSave.catch(function () {}).then(function () {
        return fetch(cartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Gift Message': value
            }
          })
        }).then(function (response) {
          if (!response.ok) {
            throw new Error('Gift message could not be saved');
          }
          return response.json();
        });
      });

      return pendingSave;
    }

    function initialiseGiftMessage(root) {
      if (root.hasAttribute('data-rb-gift-message-ready')) {
        return;
      }

      root.setAttribute('data-rb-gift-message-ready', '');

      var toggle = root.querySelector('[data-rb-gift-message-toggle]');
      var fields = root.querySelector('[data-rb-gift-message-fields]');
      var textarea = root.querySelector('[data-rb-gift-message-text]');
      var count = root.querySelector('[data-rb-gift-message-count]');
      var status = root.querySelector('[data-rb-gift-message-status]');
      var counterTemplate = root.getAttribute('data-rb-gift-message-counter');
      var dirty = false;

      function setStatus(key) {
        status.textContent = root.getAttribute('data-rb-gift-message-' + key) || '';
      }

      function updateCount() {
        count.textContent = counterTemplate.replace('__count__', textarea.value.length);
      }

      function updateExpandedState(expanded) {
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        fields.hidden = !expanded;
      }

      function persist(value) {
        window.clearTimeout(saveTimer);
        setStatus('saving');

        return saveMessage(value).then(function () {
          dirty = false;
          setStatus(value ? 'saved' : 'removed');
        }).catch(function (error) {
          setStatus('error');
          throw error;
        });
      }

      toggle.addEventListener('change', function () {
        updateExpandedState(toggle.checked);

        if (toggle.checked) {
          textarea.focus();
          return;
        }

        textarea.value = '';
        dirty = true;
        updateCount();
        persist('').catch(function () {});
      });

      textarea.addEventListener('input', function () {
        dirty = true;
        updateCount();
        setStatus('saving');
        window.clearTimeout(saveTimer);
        saveTimer = window.setTimeout(function () {
          persist(textarea.value).catch(function () {});
        }, 400);
      });

      textarea.addEventListener('blur', function () {
        if (dirty) {
          persist(textarea.value).catch(function () {});
        }
      });

      if (root.getAttribute('data-rb-gift-message-location') === 'product') {
        var productForm = root.closest('form[action*="/cart/add"]');

        if (productForm) {
          productForm.addEventListener('submit', function (event) {
            if (!dirty || productForm.hasAttribute('data-rb-gift-message-submitting')) {
              return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();
            window.clearTimeout(saveTimer);

            var submitter = event.submitter;

            persist(toggle.checked ? textarea.value : '').then(function () {
              productForm.setAttribute('data-rb-gift-message-submitting', '');

              if (productForm.requestSubmit) {
                productForm.requestSubmit(submitter || undefined);
              } else {
                productForm.submit();
              }

              productForm.removeAttribute('data-rb-gift-message-submitting');
            });
          }, true);
        }
      }

      updateCount();
    }

    function initialiseAllGiftMessages() {
      document.querySelectorAll('[data-rb-gift-message]').forEach(initialiseGiftMessage);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseAllGiftMessages);
    } else {
      initialiseAllGiftMessages();
    }

    document.addEventListener('shopify:section:load', initialiseAllGiftMessages);
  })();
  } catch(e) { console.error(e); }
})();

})();
